/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */

import {Schema, arrayOf, normalize} from 'normalizr';

export const FETCH_COLLECTION = 'fetch-collection';
export const APPEND_COLLECTION = 'append-to-collection';
export const CLEAR_COLLECTION = 'clear-collection';
export const FETCH_PACKAGES = 'fetch-packages';
export const FETCH_PLANS = 'fetch-plans';
export const SEARCH_KEYWORDS = 'search-by-keywords';
export const SEARCH_RELATED = 'search-related-content';

const asset = new Schema('asset');

export function GetCollection(query, key) {

  if (!query.categories.length) {

    return {
      type: FETCH_COLLECTION,
      meta: { key, limit: query.limit },
      payload: Promise.resolve([])
    }
  }

  return {
    type: FETCH_COLLECTION,
    meta: { key, limit: query.limit },
    payload: lh.asset.getAssets({
      filters: [
        //TODO: FUCK this category vs categories
        lh.models.viewAsset.accessor.genre_id.in(query.genres),
        lh.models.asset.accessor.category.in(query.categories),
        lh.models.asset.accessor.view.in(query.views || ['vod', 'live'])
      ],
      select: [
        lh.models.asset.schema.id,
        lh.models.asset.schema.has_adult_content,
        lh.models.asset.schema.ratings,
        lh.models.asset.schema.resources,
        lh.models.asset.schema.title,
        lh.models.asset.schema.description,
        lh.models.asset.schema.duration,
        lh.models.asset.schema.year,
        lh.models.asset.schema.offers,
        lh.models.asset.schema.package_id,
        lh.models.channelAsset.schema.er_lcn,
        lh.models.channelAsset.schema.channel_type,
        lh.models.viewAsset.schema.package_type,
        lh.models.viewAsset.schema.tv_series_seasons
      ],
      sort: query.sortBy,
      offset: 0,
      limit: query.limit + 1
    })
  };
}

export function AppendCollection(query, key) {

  return {
    type: APPEND_COLLECTION,
    meta: { key, limit: query.limit },
    payload: lh.asset.getAssets({
      filters: [
        lh.models.viewAsset.accessor.genre_id.in(query.genres),
        lh.models.asset.accessor.category.in(query.categories),
        lh.models.asset.accessor.view.in(query.views || ['vod', 'live'])
      ],
      select: [
        lh.models.asset.schema.id,
        lh.models.asset.schema.has_adult_content,
        lh.models.asset.schema.ratings,
        lh.models.asset.schema.resources,
        lh.models.asset.schema.title,
        lh.models.asset.schema.description,
        lh.models.asset.schema.duration,
        lh.models.asset.schema.year,
        lh.models.asset.schema.offers,
        lh.models.asset.schema.package_id,
        lh.models.channelAsset.schema.channel_type,
        lh.models.channelAsset.schema.er_lcn,
        lh.models.viewAsset.schema.package_type,
        lh.models.viewAsset.schema.tv_series_seasons
      ],
      sort: query.sortBy,
      offset: query.offset || 0,
      limit: query.limit + 1
    })
  };
}


export function ClearCollection(key) {

  return {
    type: CLEAR_COLLECTION,
    meta: { key },
    payload: []
  };
}

export function GetPackages() {

  return {
    type: FETCH_PACKAGES,
    payload: lh.packages.getPackages()
  };
}

export function GetOffers() {

  return {
    type: FETCH_PLANS,
    payload: lh.plans.getPlans()
  };
}

export function Search(searchTerm) {

  return {
    type: SEARCH_KEYWORDS,
    payload: lh.asset.search(searchTerm)
      .then((collection) => {

        return normalize(collection, arrayOf(asset));
      })
  };
}

export function Related(assetId) {

  return {
    type: SEARCH_RELATED,
    payload: lh.asset.searchRelated(assetId)
      .then((collection) => {

        return normalize(collection, arrayOf(asset));
      })
  };
}



// WEBPACK FOOTER //
// ./src/actions/collection/actions-collection.js